var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C6.8625 0 7.6125 0.485156 7.98984 1.19766C8.76094 0.960937 9.63281 1.14844 10.2422 1.75781C10.8516 2.36719 11.0391 3.24141 10.8023 4.01016C11.5148 4.3875 12 5.1375 12 6C12 6.8625 11.5148 7.6125 10.8023 7.98984C11.0391 8.76094 10.8516 9.63281 10.2422 10.2422C9.63281 10.8516 8.75859 11.0391 7.98984 10.8023C7.6125 11.5148 6.8625 12 6 12C5.1375 12 4.3875 11.5148 4.01016 10.8023C3.23906 11.0391 2.36719 10.8516 1.75781 10.2422C1.14844 9.63281 0.960937 8.75859 1.19766 7.98984C0.485156 7.6125 0 6.8625 0 6C0 5.1375 0.485156 4.3875 1.19766 4.01016C0.960937 3.23906 1.14844 2.36719 1.75781 1.75781C2.36719 1.14844 3.24141 0.960937 4.01016 1.19766C4.3875 0.485156 5.1375 0 6 0ZM8.64844 4.89844C8.86875 4.67812 8.86875 4.32188 8.64844 4.10391C8.42813 3.88594 8.07188 3.88359 7.85391 4.10391L5.25234 6.70547L4.15078 5.60391C3.93047 5.38359 3.57422 5.38359 3.35625 5.60391C3.13828 5.82422 3.13594 6.18047 3.35625 6.39844L4.85625 7.89844C5.07656 8.11875 5.43281 8.11875 5.65078 7.89844L8.64844 4.89844Z",
    fill: "#BADAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.39ad526653e4dece39b388286f27f6ce.svg";
export { ForwardRef as ReactComponent };